import { ng } from "@common/ngds";
import { Drawer } from "@common/components/Rendering";
import { ArrowId, long_reinf_flagged_style, long_reinf_style } from "../ViewportStyles";

// diameter is always stored in millimeters for reinforcement bars (unlike the rest of the
// geometry, which is in meters) - this constant documents the mm -> m conversion factor used
// everywhere a bar diameter is turned into a world-space (meter) radius.
export const REBAR_DIAMETER_MM_TO_RADIUS_M = 1 / 2000;

export const getStandaloneBars = (data: ng.project.Data | null): ng.reinf.StandAloneBar[] => {
  const inputJson = data?.input;
  const structureJson = inputJson?.structures[0] || null;
  const element = structureJson?.elements?.[0] || null;
  const beam = element?.getBeam() || null;
  const rebars = beam?.getConcrete()?.rebars || null;
  return rebars?.standaloneBars ?? [];
};

/**
 * `flagged` holds the bars to draw as wrong, by guid, with the reasons that become their hover title
 * (see useExactBarMarks).
 */
export const drawLongitudalReinforcement = (
  drawer: Drawer<ArrowId>,
  data: ng.project.Data | null,
  flagged: ReadonlyMap<string, string[]> = new Map(),
) => {
  const standaloneBars = getStandaloneBars(data);
  for (const bar of standaloneBars) {
    const p = bar.startPoint;
    if (!p) continue;
    const reasons = flagged.get(bar.id?.guid ?? "");
    // note: diameter is in mm and drawer uses radius and meters
    drawer.drawCircle(
      [p.y, -p.z],
      bar.diameter * REBAR_DIAMETER_MM_TO_RADIUS_M,
      reasons ? long_reinf_flagged_style : long_reinf_style,
      { title: reasons ? reasons.join("\n") : `(${p.y} ${p.z})` },
    );
  }
};
